import './Icon.scss'

import React, {SVGProps} from 'react'
import * as icons from '../../assets/icons'

export type IconKey = keyof typeof icons

export const Icon: React.FC<{
	className?: string
	icon: IconKey | React.FC<SVGProps<SVGSVGElement>>
}> = ({icon, ...rest}) => {
	const IconComponent = typeof icon === 'string' ? icons[icon] : icon
	return <IconComponent {...rest} className="icon" />
}
